import React, { useEffect, useState,useRef } from "react";
import "./ReviewRegistrationPopup.css";
import constants from '../../services/constants';
import axios from "axios";
import { useSelector } from "react-redux";
const ReviewRegistrationPopup = ({ eventDetailData, onClose,formatDate }) => {
   const [spousePrice,setSpousePrice] = useState(0)
   const [guestPrice,setGuestprice] = useState(0)
   const [totalAmt,setTotalAmt] = useState(0)
   const userSpouseList = JSON.parse(localStorage.getItem('userSpouseList'))
   const userGuestList = JSON.parse(localStorage.getItem('userGuestList'))
   const registrationCharge = JSON.parse(localStorage.getItem('registrationChargeDetail'))
   const memberShipDetails = JSON.parse(localStorage.getItem('memberShipDetail'))
   const { user} = useSelector((state) => state.auth);
   const hiddenInputRef = useRef(null);
   useEffect(()=>{
    setSpousePrice(userSpouseList.length * registrationCharge.spouseCharges)
    setGuestprice(userGuestList.length * registrationCharge.guestCharges)
    
   },[userSpouseList,userGuestList])

   useEffect(()=>{
    setTotalAmt(parseInt(memberShipDetails.memberShipCost) + parseInt(spousePrice) + parseInt(guestPrice))
   },[spousePrice,guestPrice])
   
   console.log(userSpouseList)
   console.log(userGuestList)

   const handlePayment = async () => {
   
    //alert(hiddenInputRef.current.value);
    try {
        const response = await axios.post(`${constants.API_BASE_URL}payment/initiate`, {
            amount: totalAmt,
            transactionId: `TXN_${Date.now()}`, // Unique transaction ID
            userId: `USER_${user._id}` // Replace with actual user ID
        });

        if (response.data.success) {
            window.location.href = response.data.data.redirectUrl; // Redirect to PhonePe payment page
        }
    } catch (error) {
        console.error("Payment Error:", error);
        alert("Payment initiation failed. Please try again.");
    }
 };
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="popup-header">
          <button className="back-button" onClick={onClose}>
            ←
          </button>
          <h3>Review Registration</h3>
          <button className="search-button"></button>
        </div>
        <div className="popup-content">
          <div className="event-details">
            <h4>{eventDetailData.title}</h4>
            <div className="event-info">
              <p>
                <span>Date:</span> {formatDate(eventDetailData.eventDate)}
              </p>
              <p>
                <span>Time:</span> {formatDate(eventDetailData.startTime)} - {formatDate(eventDetailData.endTime)}
              </p>
              <p>
                <span>Location:</span> {eventDetailData.address}
              </p>
            </div>
          </div>
          <div className="amount-details">
            <h4>Amount to be Paid:</h4>
            <div className="amount-row">
              <span>Life Member Fee</span>
              <span>Rs. {memberShipDetails.memberShipCost}/-</span>
            </div>
            <div className="amount-row">
              <span>Spouse/Guardian</span>
              <span>Rs. {spousePrice}/-</span>
            </div>
            <div className="amount-row">
              <span>Guest</span>
              <span>Rs. {guestPrice}/-</span>
            </div>
            <div className="total-amount">
              <span>Total Amount</span>
              <span>Rs. {totalAmt}/-</span>
            </div>
            <input type="hidden" name="evtID" ref={hiddenInputRef} value={eventDetailData._id} />
          </div>
          <button className="pay-now-button" onClick={handlePayment}>PAY NOW</button>
        </div>
      </div>
    </div>
  );
};

export default ReviewRegistrationPopup;
